( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-image-carousel').each(function() {
			const sliderId = $(this).data('slider-id');
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 'auto',
				spaceBetween: 20,

				breakpoints: {
					640: {
						spaceBetween: 40,
					},
					768: {
						spaceBetween: 60,
					},
					1024: {
						spaceBetween: 40
					},
				},

				navigation: {
					nextEl: '.js-image-carousel-nav--' + sliderId + ' .js-carousel-nav-next',
					prevEl: '.js-image-carousel-nav--' + sliderId + ' .js-carousel-nav-prev',
				},

				pagination: {
					el: '.js-image-carousel-pagination--' + sliderId,
					type: 'progressbar',
				},

				on: {
					afterInit: function(swiper) {
						const slideTotal = swiper.slides.length;
						const slidePerView = swiper.params['slidesPerView'];

						if ( slidePerView >= slideTotal) {
							console.log($(this));
							$('.js-image-carousel-nav--' + sliderId).css('display', 'none');
						}
					}
				}
			});

		});
	} );
} )( jQuery, document, window );
